import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { injectIntl } from 'react-intl'
import { goBack, push } from 'connected-react-router'
import { reset } from 'redux-form'
import { get, isEqual } from 'lodash'
import { compose } from 'recompose'
import appConfig from 'config'
import { routerAdapter } from 'helpers/decorators'

import {
  awards as awardsApi,
  blobs as blobsApi,
  configuration,
  participants as participantsApi,
  persons as personsApi,
  tasks as tasksApi
} from 'redux/modules/api'
import { logError, modal, notification, onRefreshPage, requestDownload, setPage } from 'redux/modules/app'
import {
  awardModeScheme,
  changeLevelSchema,
  createPreparationTraining,
  editPreparationTraining,
  removePreparationTraining,
  reviseAwardSchema,
  updatePaymentSchema,
  updateSchema,
  uploadFilesSchema
} from 'models/awards'

import { LEVELS } from 'constants/enums'
import { changeAwardType } from '../../../../redux/modules/api/awards'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      routerAdapter(),
      withRouter,
      injectIntl,
      routerAdapter(),

    connect(
        ({ api, auth, app }) => ({
          awards: api.awards,
          blobs: api.blobs,
          localUnassignedParticipants: api.tasks.unassignedParticipants,
          localRegistrationParticipants: api.tasks.registrationParticipants,
          localAwardSignoff: api.tasks.awardSignoff,
          user: auth.user,
          activeOrganizationId: auth.organization.id,
          commonLimit: app.commonLimit
        }),
        {
          ...awardsApi,
          getTasksUnassignedParticipants: tasksApi.unassignedParticipants
            .getTasksUnassignedParticipants,
          getTasksParticipantRegistration: tasksApi.registrationParticipants
            .getTasksParticipantRegistration,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          getTasksAwardSignoff: tasksApi.awardSignoff.getTasksAwardSignoff,
          getTasksAwardOfficeSignoff: tasksApi.awardSignoff
            .getTasksAwardOfficeSignoff,
          getTasksAwardOfficeSignoffLocally: tasksApi.awardSignoff
            .getTasksAwardOfficeSignoffLocally,
          getParticipant: participantsApi.getParticipant,
          getTasksAjPreparationAndTraining: tasksApi.aj
            .getTasksAjPreparationAndTraining,
          uploadBlob: blobsApi.uploadBlob,
          personEmailConfirmation: personsApi.personEmailConfirmation,
          notification,
          getConfigurationKeyValues: configuration.getConfigurationKeyValues,
          modal,
          logError,
          requestDownload,
          setPage,
          push,
          goBack,
          reset,
          onRefreshPage
        }
      )
    )

    class Awards extends Component {
      static propTypes = {
        decoAwardId: PropTypes.number,
        user: PropTypes.object,
        activeOrganizationId: PropTypes.number.isRequired,
        awards: PropTypes.object.isRequired,
        intl: PropTypes.object.isRequired,
        localUnassignedParticipants: PropTypes.object.isRequired,
        localRegistrationParticipants: PropTypes.object.isRequired,
        localAwardSignoff: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        getAward: PropTypes.func.isRequired,
        getAwardFiles: PropTypes.func.isRequired,
        getAwardFile: PropTypes.func.isRequired,
        uploadAwardFiles: PropTypes.func.isRequired,
        deleteAwardFile: PropTypes.func.isRequired,
        editAwardFile: PropTypes.func.isRequired,
        getAwards: PropTypes.func.isRequired,
        getAwardPreparationTrainings: PropTypes.func.isRequired,
        assignLeader: PropTypes.func.isRequired,
        getAwardReport: PropTypes.func.isRequired,
        signoffAward: PropTypes.func.isRequired,
        signoffAwardOffice: PropTypes.func.isRequired,
        getSignoffAwardOfficeIsAuthorized: PropTypes.func.isRequired,
        getTasksUnassignedParticipants: PropTypes.func.isRequired,
        allowedAwardLevels: PropTypes.func.isRequired,
        allowedOfflineAwardLevels: PropTypes.func.isRequired,
        resendParentalConsentLink: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        getTasksAwardSignoff: PropTypes.func.isRequired,
        getTasksAwardOfficeSignoff: PropTypes.func.isRequired,
        getTasksAwardOfficeSignoffLocally: PropTypes.func.isRequired,
        updateAwardPaymentInfo: PropTypes.func.isRequired,
        personEmailConfirmation: PropTypes.func.isRequired,
        getAwardLeaderSignOffs: PropTypes.func.isRequired,
        getTasksParticipantRegistration: PropTypes.func.isRequired,
        getAwardsOverview: PropTypes.func.isRequired,
        getAwardsOverviewCount: PropTypes.func.isRequired,
        setAwardsOverviewFilter: PropTypes.func.isRequired,
        setAwardsOverviewParams: PropTypes.func.isRequired,
        onGetTasksParticipantRegistration: PropTypes.func,
        getParticipant: PropTypes.func.isRequired,
        updateAward: PropTypes.func.isRequired,
        changeLeader: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        inviteParticipantToNextLevel: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        requestDownload: PropTypes.func.isRequired,
        approveAjPreparationTraining: PropTypes.func.isRequired,
        changeAwardState: PropTypes.func.isRequired,
        getTasksAjPreparationAndTraining: PropTypes.func,
        crudAwardPreparationTraining: PropTypes.func,
        removeAwardFilesData: PropTypes.func,
        removeAwardData: PropTypes.func,
        setAwardsParams: PropTypes.func,
        commonLimit: PropTypes.number,
        setPage: PropTypes.func,
        push: PropTypes.func,
        onRefreshPage: PropTypes.func,
        goBack: PropTypes.func,
        decoFilter: PropTypes.string,
        uploadBlob: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        getConfigurationKeyValues: PropTypes.func,
        changeAjPrepAndTrainState: PropTypes.func,
        changeAwardType: PropTypes.func
      }

      static defaultProps = {
        params: {}
      }

      constructor(props) {
        super(props)
        this.key = uuid.v1()
      }

      componentDidMount() {
        let { awards } = this.props
        const { params, decoAwardId, commonLimit, setAwardsParams } = this.props

        if (config.useCommonLimit && commonLimit) {
          awards = {
            ...awards,
            limit: commonLimit
          }
          setAwardsParams({ limit: commonLimit })
        }

        config.list && this.handleGetAwards(awards, this.handleGetBaseFilter())

        config.files && this.handleGetAwardFiles(decoAwardId || params.id)
        config.fileDetail &&
        this.handleGetAwardFile(decoAwardId || params.id, params.fileId)
        config.detail && params.id && this.handleGetAward(params.id)
        config.detailWithoutParam && decoAwardId && this.handleGetAward(decoAwardId)
        config.preparationTrainings && decoAwardId && this.handleGetAwardPreparationTrainings(decoAwardId)
      }

      componentWillReceiveProps(nextProps) {
        const { awards, decoAwardId } = this.props
        const { filter, limit, offset, sort } = nextProps.awards

        if (
          awards.filter !== filter ||
          awards.limit !== limit ||
          awards.offset !== offset ||
          awards.sort !== sort
        ) {
          config.list &&
          this.handleGetAwards(nextProps.awards, this.handleGetBaseFilter())
        }

        if (config.listOverview) {
          const { filter, limit, offset, sort, invalidate } = nextProps.awards.overview

          const overview = awards.overview

          if (overview.filter !== filter ||
            overview.limit !== limit ||
            overview.offset !== offset ||
            overview.sort !== sort ||
            overview.invalidate !== invalidate) {

            const reloadCount=
              overview.filter !== filter || overview.invalidate !== invalidate

            this.handleGetAwardsOverview(nextProps.awards.overview, this.handleGetBaseFilter(), reloadCount)
          }
        }

        if (decoAwardId && decoAwardId !== nextProps.decoAwardId) {
          config.files &&
          this.handleGetAwardFiles(
            nextProps.decoAwardId || nextProps.params.id
          )
        }
      }

      componentWillUnmount() {
        this.props.removeAwardFilesData()
        config.purgeOnUnmount && this.props.removeAwardData()
      }



      handleGetAwardsOverview = (awards, baseFilter, reloadCount) => {
        this.props.getAwardsOverview(awards, baseFilter)
          .catch(this.handleError)

        reloadCount && this.props
          .getAwardsOverviewCount(awards, baseFilter)
          .catch(this.handleError)
      }

      handleLoadConfiguration = award => {
        if (config.detailConfiguration && award) {
          const orgId = get(award, 'organization.id')

          orgId && this.props.getConfigurationKeyValues(config.detailConfiguration, { organizationId: orgId }).catch(this.handleError)
        }
      }

      handleGetBaseFilter = filter => {
        const { params, decoFilter } = this.props

        switch (decoFilter || config.filter || filter) {
          case 'participantsAwards':
            return `participant.id=${params && params.id}`
          case 'participantsBronzeAwards':
            return `participant.id=${params && params.id},awardLevel.value=${LEVELS.BRONZE.value}`
          case 'participantsSilverAwards':
            return `participant.id=${params && params.id},awardLevel.value=${LEVELS.SILVER.value}`
          case 'participantsGoldAwards':
            return `participant.id=${params && params.id},awardLevel.value=${LEVELS.GOLD.value}`
          case 'organizationAwards':
            return `organization.flatHierarchy.parentOrganization.id=${
              params.id
            }`
          default:
            return ''
        }
      }

      handleRefreshAwardsList = () => {
        const { awards } = this.props

        config.list && this.handleGetAwards(awards, this.handleGetBaseFilter())
      }

      handleGetAwards = (awards, baseFilter, { withTs } = {}) =>
        this.props
          .getAwards(awards, baseFilter, config.listReadParams, { withTs })
          .then(({ body }) =>
            body && body[0] && body[0].id
            && this.handleGetAuthorizedSignoffAward(body[0].id)
            && this.handleLoadConfiguration(body[0])
          )
          .catch(this.handleError)

      handleGetAuthorizedSignoffAward = awardId =>
        this.props.getSignoffAwardOfficeIsAuthorized(awardId)
          .catch(this.handleError)

      handleGetAward = id =>
        this.props
          .getAward(id, config.detailReadParams)
          .then(({ body }) =>
            this.props.setPage(
              `${get(body, 'participant.firstName')} ${get(body, 'participant.lastName')}`,
              false,
              {
                participantId: get(body, 'participant.id')
              }
            )
          )
          .catch(this.handleError)

      handleGetAwardFiles = id =>
        this.props.getAwardFiles(id).catch(this.handleError)

      handleGetAwardFile = (id, fileId) =>
        this.props.getAwardFile(id, fileId).then(({ body = {} }) =>
          this.props.setPage(
            `${get(body[0], 'logicalFilename') || this.props.intl.formatMessage(
              {
                id: 'pageTitle.award_documents',
                defaultMessage: 'Award documents'
              }
            )}`,
            true
          )
        )

      handleGetAwardPreparationTrainings = id =>
        this.props.getAwardPreparationTrainings(id)

      handleChangeLeader = (awardId, leaderId) =>
        this.props
          .changeLeader(awardId, leaderId)
          .then(({ body = {} }) =>
            this.handleEnd(
              'Award Leader has been assigned',
              'notifications.award_leader_has_been_assigned',
              { id: body.id }
            )
          )
          .catch(this.handleError)

      handleAssignLeader = (id, fields) =>
        this.props
          .assignLeader(id, fields)
          .then(() =>
            this.handleEnd(
              'Participant has been assigned',
              'notifications.participant_has_been_assigned'
            )
          )
          .catch(this.handleError)

      handleApproveSignoffAward = (id, fields) =>
        this.props
          .signoffAward(id, { approved: true, note: fields.note })
          .then(() => {
            this.handleEnd(
              'Award has been signed off',
              'notifications.award_has_been_signed_off'
            )
          })
          .catch(this.handleError)

      handleApproveSignoffAwardOffice = (id, fields) => {
        this.props
          .signoffAwardOffice(id, { approved: true, note: fields.note })
          .then(() =>
            this.handleEnd(
              'Award has been signed off',
              'notifications.award_has_been_signed_off'
            )
          )
          .catch(this.handleError)}

      handleReturnSignoffAward = (id, fields) => {
        return this.props
          .signoffAward(id, reviseAwardSchema(fields))
          .then(() =>
            this.handleEnd(
              'Award has been returned',
              'notifications.award_has_been_returned'
            )
          )
          .catch(this.handleError)
      }

      handleReturnSignoffAwardOffice = (id, fields) =>
        this.props
          .signoffAwardOffice(id, { approved: false, note: fields.note })
          .then(() =>
            this.handleEnd(
              'Award has been returned',
              'notifications.award_has_been_returned'
            )
          )
          .catch(this.handleError)

      handleChangeAwardState = (id, state, { note } = {}) => {
        this.props
          .changeAwardState(id, state, { value: note })
          .then(() => {
            this.handleEnd(
              'Award has been updated',
              'notifications.award_has_been_updated'
            )
          })
          .catch(this.handleError)
      }

      handleAddPreparationTraining = (awardId, collection, newField) =>
        this.props
          .crudAwardPreparationTraining(
            awardId,
            createPreparationTraining(collection, newField)
          )
          .then(() =>
            this.handleCrudTrainingSuccess(
              'Preparation and training has been added',
              'notifications.preparation_training_has_been_added'
            )
          )
          .catch(this.handleError)

      handleRemovePreparationTraining = (awardId, collection, idToRemove) =>
        this.props
          .crudAwardPreparationTraining(
            awardId,
            removePreparationTraining(collection, idToRemove)
          )
          .then(() =>
            this.handleCrudTrainingSuccess(
              'AJ Preparation & training has been removed',
              'notifications.preparation_training_has_been_removed'
            )
          )
          .catch(this.handleError)

      handleEditPreparationTraining = (awardId, collection) => {
        this.props
          .crudAwardPreparationTraining(
            awardId,
            editPreparationTraining(collection)
          )
          .then(() =>
            this.handleCrudTrainingSuccess(
              'AJ Preparation & training has been updated',
              'notifications.preparation_training_has_been_updated'
            )
          )
          .catch(this.handleError)
      }

      handleApproveAjPreparationTraining = id =>
        this.props
          .approveAjPreparationTraining(id, { approved: true })
          .then(() =>{
              this.props.notification(
                  'AJ Preparation & training has been approved', {
                      status: 'success',
                      intlKey: 'notifications.aj_preparation_training_has_been_approved'
                  })

              this.handleGetAward(id)
              this.props.getTasksAjPreparationAndTraining(this.props.awards)
              this.props.modal(null)
          })
          .catch(this.handleError)

      handleReturnAjPreparationTraining = (id, fields) =>
        this.props
          .approveAjPreparationTraining(id, {
            approved: false,
            note: fields.note
          })
          .then(() =>{
              this.props.notification(
                  'AJ Preparation & training has been returned', {
                      status: 'success',
                      intlKey: 'notifications.aj_preparation_training_has_been_returned'
                  })

              this.handleGetAward(id)
              this.props.modal(null)
          })
          .catch(this.handleError)

      handleChangeAjPrepAndTrainState = (id, state) => {
          this.props.changeAjPrepAndTrainState(id, state)
              .then(() => {
                    this.props.notification(
                      'State of Adventure Journey Preparation & training has been changed.', {
                       status: 'success',
                       intlKey: 'notifications.state_aj_preparation_training_has_been_changed'
                    })

                    this.handleGetAward(id)
                    this.props.modal(null)
                  }
              )
              .catch(this.handleError)
      }

      handleUploadAwardFiles = fields => {
        const { params, decoAwardId } = this.props
        const awardId = decoAwardId || params.id

        if (!fields.file) {
          return
        }

        return this.props
          .uploadBlob({
            file: fields.file
          })
          .then(({ body = {} }) => {
            return this.props
              .uploadAwardFiles(awardId, uploadFilesSchema(fields, body.url))
              .then(() => {
                this.handleEnd(
                  'File has been uploaded',
                  'notifications.file_has_been_uploaded'
                )
                this.props.modal(null)
                config.updateFiles &&
                this.handleGetAwardFiles(decoAwardId || params.id)
              })
              .catch(this.handleError)
          })
          .catch(this.handleError)
      }

      handleDeleteAwardFile = fileId => {
        const { params, decoAwardId } = this.props
        const awardId = decoAwardId || params.id

        this.props
          .deleteAwardFile(awardId, fileId)
          .then(() => {
            if (config.updateFile) {
              this.props.goBack()
              this.props.notification('File has been removed', {
                status: 'success',
                intlKey: 'notifications.file_has_been_removed'
              })
              return
            }
            this.handleEnd(
              'File has been removed',
              'notifications.file_has_been_removed'
            )
          })
          .catch(this.handleError)
      }

      handleEditAwardFile = fields => {
        const { params, decoAwardId } = this.props
        const awardId = decoAwardId || params.id

        this.props
          .editAwardFile(awardId, fields.id, fields)
          .then(() =>
            this.handleEnd(
              'File has been updated',
              'notifications.file_has_been_updated'
            )
          )
          .catch(this.handleError)
      }

      handleAllowedAwardLevels = awardId =>
        this.props.allowedAwardLevels(awardId)

      handleAllowedOfflineAwardLevels = awardId =>
        this.props.allowedOfflineAwardLevels(awardId)

      handleChangeAwardType = (awardId) => {
        const { params } = this.props

        this.props.changeAwardType(awardId)
          .then(() => {
            this.handleEnd(
              'Award type has been changed',
              'notifications.award_type_has_been_changed'
            )
            this.props.push(`${appConfig.publicPath}/participants/${params.id}`)
            this.props.onRefreshPage()
          })
          .catch(this.handleError)
      }

      handleChangeAwardLevel = (awardId, fields) => {
        const { params } = this.props

        this.props
          .updateAward(awardId, changeLevelSchema(fields), 'CHANGE_AWARD_LEVEL')
          .then(() => {
            this.handleEnd(
              'Award level has been changed',
              'notifications.award_level_has_been_changed'
            )
            this.props.push(`${appConfig.publicPath}/participants/${params.id}`)
            this.props.onRefreshPage()
          })
          .catch(this.handleError)
      }

      handleGetAwardLeaderSignOffs = (awardId, requestId) =>
        this.props.getAwardLeaderSignOffs(awardId, requestId)

      handleCrudTrainingSuccess = (text, intlKey) => {
        const { decoAwardId } = this.props

        this.props.notification(text, {
          status: 'success',
          intlKey
        })
        this.handleGetAwardPreparationTrainings(decoAwardId)
        this.props.modal(null)
      }

      handleAwardGenerateReport = (awardId, type) => {
        return this.props
          .getAwardReport(awardId, type)
          .then(({ body }) => {
            // const { user } = this.props

            // fetchFile(body.url, user)
            this.props.requestDownload({
              requestId: awardId,
              requestedSrc: body.url
            })
            // this.props.modal(null)
          })
          .catch(this.handleError)
      }

      handleResendParentalConsentLink = ({ awardId } = {}) =>
        this.props
          .resendParentalConsentLink(awardId)
          .then(() => {
            this.handleEnd(
              'Parental consent link has been sent',
              'notifications.parental_consent_link_has_been_sent'
            )
          })
          .catch(this.handleError)

      handleParticipantInviteToNextLevel = awardId =>
        this.props
          .inviteParticipantToNextLevel(awardId)
          .then(() => {
            this.handleEnd(
              'Invitation has been sent',
              'notifications.invitation_has_been_sent'
            )
          })
          .catch(this.handleError)

      handleEnd = (text, intlKey, { id, filter } = {}) => {
        this.props.notification(text, {
          status: 'success',
          intlKey
        })
        this.handleRefresh({ id, filter })
      }

      handleError = err => {
        console.log('error', err.body && err.body.bodyMessage)
        this.props.logError(err)
      }

      handleRefresh = ({ id, filter } = {}) => {
        const {
          localUnassignedParticipants,
          localAwardSignoff,
          localRegistrationParticipants,
          params = {},
          awards,
          decoAwardId
        } = this.props

        config.updateList &&
        this.handleGetAwards(awards, this.handleGetBaseFilter(filter), {
          withTs: true
        })
        config.updateDetail && this.handleGetAward(id || params.id)
        config.updateFiles && this.handleGetAwardFiles(decoAwardId || params.id)
        config.updateUnassignedTasks &&
        this.props.getTasksUnassignedParticipants(localUnassignedParticipants)

        if (config.updateRegistrationTasks) {
          if (this.props.onGetTasksParticipantRegistration) {
            this.props.onGetTasksParticipantRegistration(
              localRegistrationParticipants
            )
          } else {
            this.props.getTasksParticipantRegistration(
              localRegistrationParticipants
            )
          }
        }

        config.updateSignoffTasks &&
        this.props.getTasksAwardSignoff(localAwardSignoff)
        config.updateOfficeSignoffTasks &&
        this.props.getTasksAwardOfficeSignoff(localAwardSignoff, this.handleGetBaseFilter())
        config.updateOfficeSignoffTasksLocally &&
        this.props.getTasksAwardOfficeSignoffLocally(localAwardSignoff)
        config.updateParticipantDetail &&
        this.props.getParticipant(params.id, 'ORGANIZATION_COUNTRY')
        config.updatePreparationTasks &&
        this.props.getTasksAjPreparationAndTraining(awards)
        config.redirectToTasks && this.props.push(`${appConfig.publicPath}/tasks/adventurous-journey`)
        config.closeModalAfterUpdate && this.props.modal(null)

        if (
          config.updateUnassignedTasks ||
          config.updateSignoffTasks ||
          config.updateDetail ||
          config.updateList ||
          config.updatePreparationTasks ||
          config.updateRegistrationTasks ||
          config.updateOfficeSignoffTasks
        ) {
          this.props.getTasksOverview(null, {
            activeOrganizationId: this.props.activeOrganizationId,
            awardLeaderId: this.props.user.personId
          })
          this.props.modal(null)
        }

        if (config.updateFiles) {
          this.props.reset('award-file-upload')
          this.props.modal(null)
        }
      }

      handleRegistrationAwardEdit = async({
         awardPayload,
         awardUpdateDefinition,
         paymentPayload,
         awardId,
         isEmailConfirmed,
         personId
         // initialData
       }) => {

        const promisesToResolve = [
          this.props.updateAward(awardId, awardPayload, awardUpdateDefinition)
        ]

        try {
          await Promise.all(promisesToResolve)

          await this.props.updateAwardPaymentInfo(awardId, paymentPayload)
          await this.props.personEmailConfirmation(personId, awardId, {
            value: Boolean(isEmailConfirmed)
          })

          this.props.notification('Participant information has been updated', {
            status: 'success',
            intlKey: 'notifications.participant_info_updated'
          })

          this.handleRefresh()
        } catch (e) {
          this.handleError(e)
        }

        // // hell
        // // done like this because API is crashing if these promises are called simultaneously
        // return Promise.all(promisesToResolve)
        //   .then(() => {
        //     this.props
        //       .updateAwardPaymentInfo(awardId, paymentPayload)
        //       .then(() => {
        //         this.props
        //           .personEmailConfirmation(personId, awardId, {
        //             value: Boolean(isEmailConfirmed)
        //           })
        //           .then(() => {
        //             this.props.notification(
        //               'Participant information has been updated',
        //               {
        //                 status: 'success',
        //                 intlKey: 'notifications.participant_info_updated'
        //               }
        //             )
        //             this.handleRefresh()
        //           })
        //           .catch(e => {
        //             this.handleError(e)
        //           })
        //       })
        //       .catch(e => {
        //         this.handleError(e)
        //       })
        //   })
        //   .catch(e => {
        //     this.handleError(e)
        //   })
      }

      handleUpdateAward = (fields, awardId, { initialData = {} } = {}) => {
        const hasPaymentDataChanged = !isEqual(
          updatePaymentSchema(initialData),
          updatePaymentSchema(fields)
        )

        let promisesToResolve = [
          this.props
            .updateAward(
              awardId,
              updateSchema(fields),
              'START_DATE,PAYMENT_STATE,PAYMENT_CONFIRMATION,CONSENT_DELIVERY_CONFIRMATION,PARENT_INFO,CONSENT_DELIVERY_TYPE,CONSENT_DELIVERY_DATE,SURVEY_CONSENT_CONFIRMATION'
            )
            .catch(e => this.handleError(e))
        ]

        if (hasPaymentDataChanged) {
          promisesToResolve = promisesToResolve.concat(
            this.props
              .updateAwardPaymentInfo(awardId, updatePaymentSchema(fields))
              .catch(e => this.handleError(e))
          )
        }

        return Promise.all(promisesToResolve)
          .then(this.handleRefresh)
          .catch(e => this.handleError(e))
      }

      handleUpdateAwardMode = async(
        awardId,
        fields,
        { currentAwardLevel } = {}
      ) => {
        try {
          await this.props.updateAward(
            awardId,
            awardModeScheme(get(fields, 'awardMode.value')),
            'AWARD_MODE'
          )
          this.handleEnd(
            "Award's mode has been updated",
            'notification.award_mode_has_been_updated',
            {
              filter: LEVELS[currentAwardLevel.value].filter
            }
          )
        } catch (e) {
          this.handleError(e)
        }
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            key={this.key}
            assignLeader={this.handleAssignLeader}
            changeLeader={this.handleChangeLeader}
            refreshAwardsList={this.handleRefreshAwardsList}
            onRegistrationAwardEdit={this.handleRegistrationAwardEdit}
            approveSignoffAward={this.handleApproveSignoffAward}
            approveSignoffAwardOffice={this.handleApproveSignoffAwardOffice}
            returnSignoffAward={this.handleReturnSignoffAward}
            returnSignoffAwardOffice={this.handleReturnSignoffAwardOffice}
            changeAwardState={this.handleChangeAwardState}
            addPreparationTraining={this.handleAddPreparationTraining}
            removePreparationTraining={this.handleRemovePreparationTraining}
            editPreparationTraining={this.handleEditPreparationTraining}
            approveAjPreparationTraining={
              this.handleApproveAjPreparationTraining
            }
            returnAjPreparationTraining={this.handleReturnAjPreparationTraining}
            changeAjPrepAndTrainState={this.handleChangeAjPrepAndTrainState}
            uploadAwardFiles={this.handleUploadAwardFiles}
            deleteAwardFile={this.handleDeleteAwardFile}
            editAwardFile={this.handleEditAwardFile}
            fetchAllowedAwardLevels={this.handleAllowedAwardLevels}
            fetchAllowedOfflineAwardLevels={
              this.handleAllowedOfflineAwardLevels
            }
            changeAwardLevel={this.handleChangeAwardLevel}
            onGetAwardLeaderSignOffs={this.handleGetAwardLeaderSignOffs}
            onUpdateAward={this.handleUpdateAward}
            onUpdateAwardMode={this.handleUpdateAwardMode}
            awardGenerateReport={this.handleAwardGenerateReport}
            resendParentalConsentLink={this.handleResendParentalConsentLink}
            inviteParticipantToNextLevel={
              this.handleParticipantInviteToNextLevel
            }
            localUnassignedParticipants={undefined}
            localRegistrationParticipants={undefined}
            onChangeAwardType={this.handleChangeAwardType}
          />
        )
      }
    }

    return enhance(Awards)
  }
}

export default decorator
